const HASH_KEY = "jpa_hash";

export const saveLocationHash = (hash: string | null) => {
  if (!hash) {
    localStorage.removeItem(HASH_KEY);
  } else {
    localStorage.setItem(HASH_KEY, hash);
  }
};

export const readLocationHashStorage = (): string | null => {
  return localStorage.getItem(HASH_KEY);
};
